import React, { useMemo, useState } from "react";
import { Stack } from "@mui/material";
import { connect } from "react-redux";

import { HubButtonGroupSlider, HubTableTemplate } from "../../components";
import { getUserLocation } from "../../redux/auth";
import { useGetThroughputCustomer } from "../../hooks/react-query/useScheduleData";
import { items, keys } from "./helper";
import ThroughputWorkOrdersEmpty from "./ThroughputWorkOrdersEmpty";

const ThroughputWorkOrdersTableInner = ({
  item,
  open,
  defaultLocation,
  mode,
  weeks = [],
}) => {
  const customerId = item?.customerId;
  const [selectedId, setSelectedId] = useState("all");

  const selectedWeek = useMemo(
    () => weeks.find((w) => w.key === selectedId) || null,
    [weeks, selectedId],
  );

  const { data, isLoading } = useGetThroughputCustomer({
    defaultLocation,
    customerId,
    mode,
    weekStart: selectedWeek?.start,
    weekEnd: selectedWeek?.end,
    open,
  });

  if (!open || customerId === "totals") return null;

  const filterButtons = [
    { id: "all", label: "All" },
    ...weeks.map((w) => ({ id: w.key, label: w.label })),
  ];

  const isEmpty = !isLoading && !(data || []).length;

  return (
    <Stack p="15px" gap="10px">
      {weeks.length > 0 && (
        <HubButtonGroupSlider
          buttons={filterButtons}
          selected={selectedId}
          setSelected={setSelectedId}
          sx={{ width: "fit-content" }}
        />
      )}
      {isEmpty ? (
        <ThroughputWorkOrdersEmpty
          subtitle={
            selectedWeek
              ? `No work orders for ${selectedWeek.label}.`
              : "No work orders for this customer in the selected range."
          }
        />
      ) : (
        <HubTableTemplate
          id={`ThroughputWO-${customerId}`}
          headerProps={{ items }}
          bodyProps={{ items: data || [], keys }}
          isLoading={isLoading}
          sx={{ minHeight: "300px" }}
        />
      )}
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});

const ThroughputWorkOrdersTable = connect(mapStateToProps)(
  ThroughputWorkOrdersTableInner,
);
export default ThroughputWorkOrdersTable;
